module.exports = __webpack_public_path__ + "static/media/marks-card-bg.d5d7dcb2.png";